import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VedExportButtons = _resolveComponent("VedExportButtons")!

  return (_openBlock(), _createBlock(_component_VedExportButtons, {
    disabled: _ctx.disabled,
    loading: _ctx.isExportProgress,
    excelPermissionCode: _ctx.config.excel.permissionCode,
    onExportExcel: _ctx.exportExcel,
    onExportPdf: _ctx.printPage
  }, null, 8, ["disabled", "loading", "excelPermissionCode", "onExportExcel", "onExportPdf"]))
}